import OMT_UI_SquareButton, { BUTTONCOLOURS } from '../../OMT_UI/OMT_UI_SquareButton';

export default class WorldMapGateLayer extends Phaser.Group {
  constructor(map) {
    super(game);

    this.map = map;
    this.position = this.map.position;
    this._gatesEntries = this._createGatesMap();

    this.minGateY = null;

    this.onGateOpen = new Phaser.Signal();

    G.sb('onWindowOpened').add(this.lockInput, this);
    G.sb('onWindowClosed').add(this.unlockInput, this);

    this.signalBinding = this.map.signals.onMapScrolled.add(G.Helpers.callOnThreshold(100, this._checkInstancesPlacements, this));
  }

  destroy() {
    this.onGateOpen.dispose();
    if (this.signalBinding._listener) {
      this.map.signals.onMapScrolled.remove(this.signalBinding._listener, this);
    }
    for (const gate in this._gatesEntries) {
      if (gate.instance) {
        gate.instance.destroy();
      }
    }
    super.destroy();
  }

  getMinY() {
    if (this._gatesEntries.length === 0) {
      return Infinity;
    }
    return this._gatesEntries[0].mapY * -1;
  }

  unlockInput() {
    this.ignoreChildInput = false;
    this.children.forEach((child) => { child.ignoreChildInput = false; }); // eslint-disable-line no-param-reassign
  }

  lockInput() {
    this.ignoreChildInput = true;
    this.children.forEach((child) => { child.ignoreChildInput = true; }); // eslint-disable-line no-param-reassign
  }


  _createGatesMap() {
    const { gatesMgr } = G.Helpers;

    return gatesMgr.getUnopenedGatesIds().map((gateId) => {
      const gateObject = gatesMgr.getGateObject(gateId);
      return {
        gateObject,
        instance: null,
        mapY: gateObject.getMapPosition().y,
      };
    }, this);
  }

  _checkInstancesPlacements() {
    for (let i = 0, len = this._gatesEntries.length; i < len; i++) {
      const entry = this._gatesEntries[i];
      if (entry.mapY < (this.y + 200) * -1) {
        return;
      } else { // eslint-disable-line no-else-return
        if (!entry.instance) { // eslint-disable-line no-lonely-if
          entry.instance = this._addGate(entry.gateObject);
        }
      }
    }
  }

  _addGate(gateObject) {
    const gateInstance = new Gate(gateObject); // eslint-disable-line no-use-before-define
    this.add(gateInstance);
    // if (!gateInstance.onOpen.has(this._onGateOpen, this)) {
    gateInstance.onOpen.add(this._onGateOpen, this);
    // }

    // Save a reference to the onOpen signal in gatesMgr so the Treasure Hunt UI elements can dispatch them
    G.Helpers.gatesMgr.instances[gateObject.getId()] = gateInstance;
    return gateInstance;
  }

  async _onGateOpen(gateId, showTreasureHuntWindow) {
    this.onGateOpen.dispatch(gateId, showTreasureHuntWindow);
    this._removedOpenedGateObject(gateId);

    const scheduledGateMessages = await OMT.notifications.findGameTriggeredMessages('GateOpen');
    if (scheduledGateMessages.length > 0) {
      await OMT.notifications.removeGameTriggeredMessage('GateOpen');
    }
  }

  _removedOpenedGateObject(gateId) {
    const gateEntry = this._gatesEntries.find((entry) => entry.gateObject.getId() === gateId);
    if (gateEntry) {
      this._gatesEntries.splice(this._gatesEntries.indexOf(gateEntry), 1);
      gateEntry.instance.destroy();
    }
  }
}

//

export class Gate extends Phaser.Group {
  constructor(gateObject) {
    super(game);

    const saveStateMgr = G.saveState;

    this.gateObject = gateObject;
    this.state = game.state.getCurrentState();

    this.onOpen = new Phaser.Signal();

    this.position.copyFrom(this.gateObject.getMapPosition());

    this.gateImg = G.makeImage(0, 20, 'gate', [0.5, 1], this);

    this.active = this.gateObject.getLevelIndex() <= saveStateMgr.getLastPassedLevelNr();

    if (this.active) {
      this._addUnlockButton();
    }
  }

  _addUnlockButton() {
    const { gatesMgr } = G.Helpers;

    this.unlockBtn = new OMT_UI_SquareButton(10, 30, {
      button: {
        tint: BUTTONCOLOURS.orange,
        dimensions: {
          width: 138,
          height: 70,
        },
      },
      text: {
        string: OMT.language.getText('Unlock'),
        textStyle: { style: 'font-white', fontSize: 48 },
        dimensionMods: {
          height: 0.9,
          width: 0.9,
        },
      },
      options: {
        clickFunction: {
          onClick: this.onUnlockClick.bind(this),
        },
      },
    });
    this.addChild(this.unlockBtn);

    if (this.gateObject.isReadyToOpen()) {
      this.unlockBtn.x = 0;
      this.unlockBtn.pulse(1.1);
    } else {
      this.lockImg = G.makeImage(-80, 30, 'lock', 0.5, this);
    }

    this.gateListener = gatesMgr.signals.onGateOpened.addOnce(this.unlockGate, this);
  }

  destroy() {
    if (this.gateListener && this.gateListener._listener && this.gateListener.context) {
      const { gatesMgr } = G.Helpers;
      gatesMgr.signals.onGateOpened.remove(this.gateListener._listener, this.gateListener.context);
    }
    this.onOpen.dispose();
    if (this.unlockBtn) {
      this.unlockBtn.destroy();
    }
    super.destroy();
  }

  onUnlockClick() {
    const { gatesMgr } = G.Helpers;
    gatesMgr.activateGate(this.gateObject.getId());

    if (this.gateObject.isReadyToOpen()) {
      console.log('Gate unlock: opening readyToOpen');
      this.onOpen.dispatch(this.gateObject.getId(), true);
    } else {
      G.sb('pushWindow').dispatch(['gateNew', {
        gateObject: this.gateObject,
        onOpenCallback: (gateId) => { // eslint-disable-line no-unused-vars
          this.unlock();
          this.onOpen.dispatch(this.gateObject.getId(), true);
        },
      }]);
      this.scheduleReminder();
    }
  }

  /**
   * Schedule a bot message to remind the player when the gate will open
   */
  async scheduleReminder() {
    // Schedule bot message to remind when the gate is opening
    const scheduledGateMessages = await OMT.notifications.findGameTriggeredMessages('GateOpen');
    if (scheduledGateMessages.length === 0) {
      const seconds = this.gateObject.getTimeToOpeningInSeconds();
      await OMT.notifications.scheduleGameTriggeredMessage(OMT.envData.settings.user.userId, 'GateOpen', seconds, null);
    }
  }

  unlockGate(id) {
    if (this.gateObject.getId() === id) {
      this.unlock();
    }
  }

  update() {
    this.visible = this.state.map.y + this.y > -1000;
  }

  unlock() {
    for (let i = 0; i < 10; i++) {
      G.sb('fxMap').dispatch('star', {
        x: this.worldPosition.x,
        y: this.worldPosition.y,
      });
    }

    game.add.tween(this)
      .to({ alpha: 0 }, 300, Phaser.Easing.Sinusoidal.Out, true)
      .onComplete.add(() => {
        this.destroy();
      }, this);
  }
}
